import { ProfilePredicates } from '@modules/profile/predicates';
import { Role } from '@modules/roles/model';

export namespace ParcelsSharingUtils {
  export const canAccess = ProfilePredicates.and(
    ProfilePredicates.hasAccountType(Role.AccountType.Provider),
    ProfilePredicates.canEdit(Role.AccessKey.ParcelsSharing),
  );
}
